export const APP_NAME = "FinVault";
export const APP_VERSION = "1.2.59";

export const PROFILE_TYPES = [
  { id:"standard", label:"Standard", icon:"💰", desc:"Track income & expenses",         color:"#4F46E5" },
  { id:"lending",  label:"Lending",  icon:"🤝", desc:"Money lent, borrowed & returned", color:"#059669" },
  { id:"trading",  label:"Trading",  icon:"📈", desc:"Portfolio, P&L & dividends",      color:"#D97706" },
  { id:"gold", label:"Gold", icon:"🥇", desc:"Track gold grams, cost, sales & P/L", color:"#CA8A04" },
  { id:"silver", label:"Silver", icon:"🥈", desc:"Track silver grams, cost, sales & P/L", color:"#64748B" },
  { id:"fdrd", label:"FD/RD", icon:"🏦", desc:"Track fixed & recurring deposits", color:"#0F766E" },
];

export const LEGACY_PROFILE_TYPES = [
  { id:"goldsilver", label:"Gold/Silver", icon:"🪙", desc:"Legacy combined gold & silver tracker", color:"#CA8A04", hidden:true },
];

export const ALL_PROFILE_TYPES = [...PROFILE_TYPES, ...LEGACY_PROFILE_TYPES];
export const getProfileTypeMeta = profileType => ALL_PROFILE_TYPES.find(p => p.id === profileType) || PROFILE_TYPES[0];

export const PAYMENT_METHODS = ["Cash","UPI","Card","Net Banking","Cheque","Other"];
export const FEEDBACK_TYPES = ["Bug", "Suggestion", "UI Issue", "Security Concern", "Other"];


export const CURRENCIES = [
  {code:"INR",symbol:"₹",name:"Indian Rupee"},
  {code:"USD",symbol:"$",name:"US Dollar"},
  {code:"EUR",symbol:"€",name:"Euro"},
  {code:"GBP",symbol:"£",name:"British Pound"},
  {code:"AED",symbol:"د.إ",name:"UAE Dirham"},
  {code:"SGD",symbol:"S$",name:"Singapore Dollar"},
];

export const STD_CATS = {
  income:  [{l:"Salary",icon:"💼"},{l:"Freelance",icon:"💻"},{l:"Business",icon:"🏪"},{l:"Investment",icon:"📈"},{l:"Gift",icon:"🎁"},{l:"Other",icon:"💰"}],
  expense: [{l:"Food",icon:"🍽️"},{l:"Transport",icon:"🚗"},{l:"Shopping",icon:"🛍️"},{l:"Utilities",icon:"💡"},{l:"Rent",icon:"🏠"},{l:"Health",icon:"🏥"},{l:"Entertainment",icon:"🎬"},{l:"Education",icon:"📚"},{l:"Other",icon:"📦"}],
};

export const LEND_TYPES = [
  { id:"lent",     label:"Lent Out",  icon:"➡️", color:"#DC2626", desc:"Money given to someone" },
  { id:"returned", label:"Returned",  icon:"✅", color:"#059669", desc:"Money received back" },
  { id:"borrowed", label:"Borrowed",  icon:"⬅️", color:"#7C3AED", desc:"Money you borrowed" },
  { id:"repaid",   label:"Repaid",    icon:"💸", color:"#0284C7", desc:"Money you repaid" },
];

export const TRADE_TYPES = [
  { id:"deposit",  label:"Deposit",   icon:"⬇️", color:"#059669", desc:"Add funds" },
  { id:"withdraw", label:"Withdraw",  icon:"⬆️", color:"#DC2626", desc:"Take out funds" },
  { id:"profit",   label:"Profit",    icon:"📈", color:"#16A34A", desc:"Booked gain" },
  { id:"loss",     label:"Loss",      icon:"📉", color:"#EF4444", desc:"Booked loss" },
  { id:"dividend", label:"Dividend",  icon:"💵", color:"#0284C7", desc:"Dividend received" },
];

export const GOLD_TYPES = [
  { id:"buy", label:"Buy", icon:"🛒", color:"#CA8A04", desc:"Purchased grams" },
  { id:"sell", label:"Sell", icon:"💸", color:"#059669", desc:"Sold grams" },
  { id:"cashback", label:"Cashback", icon:"🎁", color:"#7C3AED", desc:"Cashback or bonus" },
  { id:"adjustment", label:"Adjustment", icon:"⚖️", color:"#0284C7", desc:"Manual gram adjustment" },
];

export const GOLD_METALS = ["Gold", "Silver"];

export const METAL_PROFILE_TYPES = ["goldsilver", "gold", "silver"];
export const isMetalProfile = profileType => METAL_PROFILE_TYPES.includes(profileType);
export const getProfileMetal = profileType => profileType === "silver" ? "Silver" : profileType === "gold" ? "Gold" : null;
export const getMetalProfileLabel = profileType => profileType === "silver" ? "Silver" : profileType === "gold" ? "Gold" : "Gold/Silver";
export const GOLD_PLATFORMS = ["PhonePe", "Google Pay", "Paytm", "Jar", "MMTC-PAMP", "Augmont", "Other"];

export const FDRD_TYPES = [
  { id:"active", label:"Active", icon:"🏦", color:"#0F766E", desc:"Running deposit" },
  { id:"matured", label:"Matured", icon:"✅", color:"#16A34A", desc:"Closed on maturity" },
  { id:"closedEarly", label:"Closed Early", icon:"⚠️", color:"#EA580C", desc:"Premature closure" },
  { id:"renewed", label:"Renewed", icon:"🔁", color:"#4F46E5", desc:"Renewed deposit" },
  { id:"cancelled", label:"Cancelled", icon:"✖️", color:"#DC2626", desc:"Cancelled deposit" },
];

export const FDRD_DEPOSIT_TYPES = ["FD", "RD"];
export const FDRD_PAYOUTS = ["On maturity", "Monthly", "Quarterly", "Yearly", "Cumulative", "Other"];
export const FDRD_BANKS = ["SBI", "HDFC Bank", "ICICI Bank", "Axis Bank", "Kotak Mahindra Bank", "Canara Bank", "Bank of Baroda", "Indian Bank", "Post Office", "Other"];

export const ACC_COLORS = ["#4F46E5","#059669","#DC2626","#D97706","#7C3AED","#0284C7","#DB2777","#65A30D","#0F766E","#9333EA"];
export const ACC_ICONS  = ["👤","👨","👩","🧑","💼","🏠","🏦","✈️","🤝","📈","💱","🎯","🪙","🥇","🥈","🏦","💵"];
